import React, { useEffect, useState } from "react";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import useLongPress from "../hooks/useLongPress";
import useSizePercentage from "../hooks/useSizePercentage";
import RatingBar from "../misc/elements/RatingBar";
import { clamp } from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";
import FireCounter from "./FireCounter";

const makeCounter = (
  backgroundColor,
  image,
  counter,
  key,
  hoverdescription
) => {
  return {
    backgroundColor,
    image,
    counter,
    hoverdescription,
  };
};

const InnerBoxLayout = ({
  mainImage,
  leftRating,
  leftImage,
  leftUnratedImage,
  rightRating,
  rightImage,
  rightUnratedImage,
  description,
  upperBarText,
  type,
  objects,
  click,
  boxType,
}) => {
  const { setDragCursor, displayedBoxes, player } = MainStore();
  const { getBoxType } = useHandleBoxTypes();
  const [resizingBoxes, setResizingBoxes] = useState();
  const [playerCounters, setPlayerCounters] = useState([]);

  // backgroundColor, image, counter, key, hoverdescription

  useEffect(() => {
    setResizingBoxes(displayedBoxes.length > 3);
  }, [displayedBoxes]);

  const sizePercentage = useSizePercentage();
  const onLongPress = () => {
    setDragCursor({ type, objects });
  };

  const onClick = () => {
    if (click) click();
  };

  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 200,
  };

  const longPressEvent = useLongPress(onLongPress, onClick, defaultOptions);
  return (
    <div
      {...longPressEvent}
      className="divColumn"
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        backgroundColor: boxType ? boxType.colors.primary : "lightBlue",
        borderRadius: "1rem/1rem",
      }}
    >
      <div style={{ width: "100%", height: "100%", position: "absolute" }} />
      <div
        className="divRow"
        style={{
          backgroundColor: boxType ? boxType.colors.secondary : "lightBlue",
          width: "90%",
          height: "25px",
          justifyContent: "center",
        }}
      >
        <div
          className="textWhite"
          style={{ fontStyle: "italic", fontSize: "15px" }}
        >
          {upperBarText}
        </div>
      </div>
      <div
        className="divRow"
        style={{
          flex: 1,
          width: "100%",
        }}
      >
        <RatingBar
          marginLeft={"5px"}
          direction={"divColumn"}
          imageSize={
            resizingBoxes ? `${(25 / 100) * sizePercentage.total}px` : "25px"
          }
          rating={leftRating}
          image={leftImage}
          unratedImage={leftUnratedImage}
        />
        <div className="divColumn">
          <div
            className="divRow"
            style={{
              width: "100%",
              height: "25px",
              justifyContent: "space-around",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          >
            {playerCounters.map((c) => (
              <FireCounter
                resizingBoxes={resizingBoxes}
                sizePercentage={sizePercentage}
                backgroundColor={c.backgroundColor}
                image={c.image}
                counter={c.counter}
                key={c.image}
                hoverDescription={c.hoverDescription}
              />
            ))}
          </div>
          <img
            src={mainImage}
            style={{
              maxWidth: resizingBoxes ? `${sizePercentage.total}%` : "100%",
              height: "80%",
              width: resizingBoxes
                ? `${(80 / 100) * sizePercentage.total}%`
                : "80%",
            }}
          />
        </div>
        <RatingBar
          marginRight={"5px"}
          direction={"divColumn"}
          imageSize={
            resizingBoxes ? `${(25 / 100) * sizePercentage.total}px` : "25px"
          }
          rating={rightRating}
          image={rightImage}
          unratedImage={rightUnratedImage}
        />
      </div>
      <div
        className="divRow"
        style={{
          width: "95%",
          justifyContent: "center",
          alignItems: "center",
          height: "80px",
          backgroundColor: boxType ? boxType.colors.secondary : "white",
          margin: "5px",
          borderRadius: ".5rem/.5rem",
        }}
      >
        <div
          className="textBoldWhite"
          style={{
            fontSize: resizingBoxes
              ? `${clamp((20 / 100) * sizePercentage.total, 13, 25)}px`
              : "20px",
            textAlign: "center",
          }}
        >
          {description}
        </div>
      </div>
    </div>
  );
};

export default InnerBoxLayout;
